/**
 * Remueve un elemento del DOM de forma segura.
 * Evita errores de desincronización cuando React reconcilia el DOM
 * y el nodo ya fue removido antes de que se ejecute removeChild.
 */
export const safeRemoveChild = (element) => {
  try {
    if (element?.parentNode) {
      element.parentNode.removeChild(element);
    }
  } catch (e) {
    // Nodo ya fue removido por reconciliación de React
  }
};
